<!--suppress ALL -->
<template>
    <div :key="renderCount" id="custom-login-form">
        <form class="custom-form">
            <div v-for="(input, i) of inputs" :key="input._id">
                <md-field
                    v-if="input.type === 'text' && input.visible"
                    :key="input._id"
                    :class="{
                        'md-invalid': !!findError(input),
                    }"
                    :tabindex="i"
                    class="field-custom"
                >
                    <label class="field-label"
                           :class="{'label-top': values[input._id],}">{{ getLocalizedInputText(input) }}</label>

                    <md-input
                        :key="input._id"
                        v-model="values[input._id]"
                        v-validate="input.required ? 'required' : ''"
                        :autofocus="input._id === autoFocus"
                        :name="getLocalizedInputText(input)"
                        @blur="blur"
                        @click="changeAutoFocus(input._id)"
                    />
                    <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <md-field
                    v-if="input.type === 'check' && input.visible"
                    :key="input._id"
                    :class="{
                        'md-invalid': !!findError(input),
                        'special-checkbox':true,
                    }"
                    class="customCheck"
                    :tabindex="i"
                >
                    <div class="d-flex align-items-center">
                        <md-checkbox
                            ref="myCheckbox"
                            v-model="values[input._id]"
                            v-validate="input.required ? 'required:true' : ''"
                            :autofocus="input._id === autoFocus"
                            name="mami"
                            @blur="blur"
                            @click="changeAutoFocus(input._id)"
                            style="opacity:0; position:absolute;"
                        />
                        <md-checkbox
                            ref="myCheckbox"
                            :key="input._id"
                            v-model="values[input._id]"
                            v-validate="input.required ? 'required:true' : ''"
                            :autofocus="input._id === autoFocus"
                            :name="getLocalizedInputText(input)"
                            @blur="blur"
                            @click="changeAutoFocus(input._id)"
                        />

                        <span
                            style="
                                top: 8px !important;
                                margin-left: 10px;
                            "
                            class="checkbox-span"
                            v-html="getLinkWithTargetBlank(input)"
                        >
                        ><span v-if="input.required">*</span></span
                        >
                        <!--                        {{getLink(getLocalizedInputText(input))}}-->
                    </div>
                    <a-tooltip placement="topLeft"
                               title="Bu alanın onaylanması zorunludur.">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <div
                    v-if="input.type === 'label' && input.visible"
                    class="descriptionLabel"
                    :key="input._id"
                    :tabindex="i"
                    v-html="hallet(getLocalizedInputText(input))"
                />

                <md-field
                    v-if="input.type === 'fullname' && input.visible"
                    :key="input._id"
                    :class="{
                        'md-invalid': !!findError(input),
                    }"
                    :tabindex="i"
                >
                    <label :class="{
                        'label-top': values[input._id],
                    }">{{ getLocalizedInputText(input) }}<span v-if="input.required">*</span></label>

                    <md-input
                        v-model="values[input._id]"
                        v-validate="input.required ? 'required' : ''"
                        :autofocus="input._id === autoFocus"
                        :ref="getLocalizedInputText(input)"
                        :name="getLocalizedInputText(input)"
                        @blur="blur"
                        @click="changeAutoFocus(input._id)"

                    />
                    <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <md-field
                    v-if="input.type === 'email' && input.visible"
                    :key="input._id"
                    :class="{
                        'md-invalid': !!findError(input),
                    }"
                    :tabindex="i"
                    class="field-custom"
                >
                    <label
                        :class="{
                        'label-top': values[input._id],
                    }">{{ getLocalizedInputText(input) }}<span v-if="input.required">*</span></label>
                    <md-input
                        v-model.trim="values[input._id]"
                        v-validate="input.required ? 'required|email' : 'email'"
                        :autofocus="input._id === autoFocus"
                        :name="getLocalizedInputText(input)"
                        autocomplete="off"
                        data-vv-validate-on="blur"
                        type="text"
                        @blur="blur"
                        @click="changeAutoFocus(input._id)"
                    />
                    <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <md-field
                    v-if="input.type === 'phone' && input.visible"
                    :key="input._id"
                    :class="{
                        'md-invalid': getErrorItems().find((x) => x.field === $t('message.phone')) !== undefined,
                    }"
                    :tabindex="i"
                >
                    <label v-if="phoneLabelVisible" :class="{
                        'label-top': values[input._id],
                    }">{{ getLocalizedInputText(input) }}</label>
                    <SelectPhoneInput
                        :key="input._id"
                        v-model="values[input._id]"
                        :autofocus="input._id === autoFocus"
                        :name="$t('message.phone')"
                        :v-validate="input.required ? 'required' : ''"
                    />
                    <!-- Tüm Sisteme Dokunmamak İçin Kısa Yoldan Çözüm. (İncellediğimde girmem gereken yerler vardı.) -->
                    <md-input
                        style="display: none"
                        v-model="values[input._id]"
                        v-validate="input.required ? 'required' : ''"
                        :name="$t('message.phone')"
                        autocomplete="off"
                    />
                    <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <md-field
                    v-if="input.type === 'numeric' && input.visible"
                    :key="input._id"
                    :class="{
                        'md-invalid': !!findError(input),
                    }"
                    :tabindex="i"
                    class="field-custom"
                >
                    <label class="field-label" :class="{
                        'label-top': values[input._id],
                    }">{{ getLocalizedInputText(input) }}</label>
                    <md-input
                        v-model="values[input._id]"
                        v-validate="input.required ? 'required|numeric' : 'numeric'"
                        :autofocus="input._id === autoFocus"
                        :name="getLocalizedInputText(input)"
                        type="number"
                        @blur="blur"
                        @click="changeAutoFocus(input._id)"
                    />
                    <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <div v-if="input && input.type === 'city' && input.visible">
                    <md-field :key="input._id" :tabindex="i" :class="{'md-invalid': !!findError(input)}">
                        <label class="label-top">{{ $t(" message.city") }}<span v-if="input.required">*</span></label>
                        <a-select
                            id="city"
                            v-model="values[input._id]"
                            v-validate="input.required ? 'required' : ''"
                            :autofocus="input._id === autoFocus"
                            name="city"
                            ng-disabled="true"
                            class="custom-selector"
                        >
                            <a-select-option v-for="city in newCities" :key="city.id" :value="city.name"
                            >{{ city.name }}
                            </a-select-option>
                        </a-select>
                        <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')"
                                   class="warning-icon">
                            <a-icon v-if="!!findError(input)"
                                    class="mr-2 aIcon "
                                    type="exclamation-circle"
                                    style="color: red; margin-top: 10px"
                            />
                        </a-tooltip>

                    </md-field>
                </div>

                <div v-if="input.type === 'cityAndDistrict' && input.visible">
                    <md-field :key="input._id" :tabindex="i" :class="{'md-invalid': !!findError(input)}"
                    ><label class="label-top">{{ $t(" message.city") }}<span v-if="input.required">*</span></label>
                        <a-select
                            id="city"
                            v-model="selectedCityId"
                            v-validate="input.required ? 'required' : ''"
                            :autofocus="input._id === autoFocus"
                            :placeholder="$t('message.city')"
                            name="city"
                        >
                            <a-select-option v-for="city in newCities" :key="city.id" :value="city.id"
                            >{{ city.name }}
                            </a-select-option>
                        </a-select>
                        <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')"
                                   class="warning-icon">
                            <a-icon v-if="!!findError(input)"
                                    class="mr-2 aIcon"
                                    type="exclamation-circle"
                                    style="color: red; margin-top: 10px"
                            />
                        </a-tooltip>
                    </md-field>
                    <md-field :tabindex="i">
                        <label class="label-top">{{ $t("message.district") }}<span
                            v-if="input.required">*</span></label>
                        <a-select
                            id="district"
                            v-model="selectedDistrict"
                            v-validate="input.required ? 'required' : ''"
                            :autofocus="input._id === autoFocus"
                            :placeholder="$t('message.district')"
                            name="district"
                        >
                            <a-select-option v-for="district in newDistrict" :key="district.id" :value="district.name">
                                {{ district.name }}
                            </a-select-option>
                        </a-select>
                        <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')"
                                   class="warning-icon">
                            <a-icon v-if="!!findError(input)"
                                    class="mr-2 aIcon"
                                    type="exclamation-circle"
                                    style="color: red; margin-top: 10px"
                            />
                        </a-tooltip>
                    </md-field>
                </div>

                <md-field
                    v-if="input.type === 'select' && input.visible"
                    :key="input._id"
                    :class="{
        'md-invalid': !!findError(input),
    }"
                    :tabindex="i"
                >
                    <label :class="{'label-top':values[input._id]}">{{ getLocalizedInputText(input) }}<span
                        v-if="input.required">*</span></label>
                    <a-select
                        v-model="values[input._id]"
                        v-validate="input.required ? 'required' : ''"
                        data-vv-validate-on="submit"
                        :autofocus="input._id === autoFocus"
                        :name="getLocalizedInputText(input)"
                    >
                        <a-select-option v-for="(option, i) in input.options" :key="i" :value="option"
                        >{{ option }}
                        </a-select-option>
                    </a-select>
                    <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')" class="warning-icon">
                        <a-icon v-if="!!findError(input)"
                                class="mr-2 aIcon"
                                type="exclamation-circle"
                                style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <div v-if="input.type === 'subject' && input.visible" class="subject-select-elem">
                    <md-field :key="input._id" :tabindex="i" :class="{'md-invalid': !!findError(input)}">

                        <label :class="{'label-top': selectedSubject}">{{ getLocalizedInputText(input) }}<span v-if="input.required">*</span></label>
                        <a-select
                            :key="input._id"
                            v-model="selectedSubject"
                            v-validate="input.required ? 'required' : ''"
                            :autofocus="input._id === autoFocus"
                            class="department-select w-100"
                            :class="{
        'md-invalid': !!findError(input),
    }"
                            :options="
        subjects.map((type) => {
            const label = type.label;
            return { label: label, value: label };
        })
    "
                            :name="input.localizedLabel[$i18n.locale].text"
                            :tabindex="i"
                            @blur="blur"
                            @click="changeAutoFocus(input._id)"
                            dropdownClassName="department-select-dropdown"
                        >
                            <template slot="label">
                                <label :class="{'label-top':selectedSubject}">{{ $t(input.localizedLabel[$i18n.locale].text)
                                    }}<span
                                        v-if="input.required">*</span></label>
                            </template>
                        </a-select>
                        <a-tooltip placement="topLeft" :title=" $_.get(findError(input), 'msg', '')" class="warning-icon">
                            <a-icon v-if="!!findError(input)"
                                    class="mr-2 aIcon"
                                    type="exclamation-circle"
                                    style="color: red; margin-top: 10px"
                            />
                        </a-tooltip>
                    </md-field>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import LoginUser from "../svg/LoginUser.vue";
import MailForm from "../svg/MailForm";
import { log2 } from "../../utils/log2";
import Avatar from "vue-avatar";
import _ from "lodash";
import { getPersistenceData } from "../../utils/persistenceStorage";
import request from "../../utils/request";
import { sendSocketMessage, socketMessageStream } from "../../utils/socketStream";
import SelectPhoneInput from "./popup-chat/SelectPhoneInput.vue";

const log = log2("CustomLoginForm");

export default {
    name: "CustomLoginForm",
    components: {
        LoginUser,
        MailForm,
        Avatar,
        SelectPhoneInput,
    },
    data() {
        return {
            selectedCountry: "+90",
            values: {},
            lastReportedValues: null,
            cities: [],
            selectedCityId: null,
            selectedDistrict: null,
            avaibleDistricts: [],
            selectedSubject: null,
            renderCount: 0,
            autoFocus: null,
            departmentInitialized: false,
            newCities: [],
            newDistrict: [],
            phoneLabelVisible: false,
            socketMessageBuffer: [],
        };
    },
    props: {
        getValues: {
            type: Function,
            default: (cb = _.noop) => {
            },
        },
        subjects: {
            type: Array,
            default: [],
            required: true,
        },
        lastLoginData: {
            type: Object,
            default: null,
            required: false,
        },
    },
    computed: {
        ...mapState({
            inputs: (state) => state.customLoginForm.inputs,
            settings: (state) => state.setting.settings,
            preDefinedUserData: (state) => state.chat.preDefinedUserData,
            preSelectedDepartment: (state) => state.chat.preSelectedDepartment,
            socketIsOpen: (state) => state.chat.socketIsOpen,
        }),
        ...mapGetters({
            mouseUpOnWindow: "chat/mouseUpOnWindow",
            reconnecting: "chat/reconnecting",
            connecting: "chat/connecting",
        }),
        selectedCity() {
            return this.newCities.find((item) => item.id === this.selectedCityId);
        },
    },
    created() {
        log.debug("created");
        const self = this;
        this.valuesUpdated = _.debounce(function(val) {
            log("valuesUpdated", val);
            self.reportValues(val);
        }, 100);
    },
    updated() {
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
        log("updated", {
            values: this.values,
            inputs: this.inputs,
            preDefinedUserData: this.preDefinedUserData,
            lastReportedValues: this.lastReportedValues,
        });
    },
    mounted() {
        try {
            this.getCities("TR");
            this.listenSocket();
            const self = this;
            this.getValues(() => {
                if (self.reportValues) return self.reportValues(self.values);
            });
            this.fillPreSelectedSubject();
            if (this.preDefinedUserData && this.preDefinedUserData.initialized) {
                log("fillPreDefinedUserData running from mount", {
                    preDefinedUserData: this.preDefinedUserData,
                });
                this.fillPreDefinedUserData(this.preDefinedUserData);
            }
        } catch (error) {
            log(error);
        }

    },
    beforeDestroy() {
        this.socketSub.unsubscribe();
    },
    methods: {
        ...mapActions({
            setVisitorIsLogging: "chat/setVisitorIsLogging",
            setVisitorIsLoggedIn: "chat/setVisitorIsLoggedIn",
        }),
        focusOnCheckbox() {
            this.$refs.myCheckbox.focus();
        },
        getLinkWithTargetBlank(input) {
            const parser = new DOMParser();
            const text = this.getLocalizedInputText(input);
            const doc = parser.parseFromString(text, "text/html");
            doc.querySelectorAll("a").forEach(a => {
                a.setAttribute("target", "_blank");
                a.style.display = "inline-block";
            });
            return doc.body.innerHTML;
        },
        getErrorItems() {
            return _.get(this.errors, "items", []);
        },

        findError(input) {
            return this.errors.items.find((x) => x.field === this.getLocalizedInputText(input));
        },
        getLocalizedInputText(input, language) {
            language = language || this.$i18n.locale;
            const validLangs = Object.keys(input.localizedLabel || {});
            const fallbackLanguage = validLangs.includes("en")
                ? "en"
                : validLangs.includes("tr")
                    ? "tr"
                    : validLangs[0];
            language = validLangs.includes(language) ? language : fallbackLanguage;
            return _.get(input, `localizedLabel.${language}.text`);
        },
        logErrorInfo(abc) {
            // console.log("abc x", abc);
        },

        sendSocketMessageForLocation(key, data) {
            sendSocketMessage(key, data);
        },

        getCities(country) {
            log("socket is open", this.socketIsOpen);
            if (this.socketIsOpen) {
                this.sendSocketMessageForLocation("location find-states", {
                    siteId: this.siteId,
                    country,
                });
            } else {
                this.socketMessageBuffer.push({
                    key: "location find-states",
                    data: {
                        siteId: this.siteId,
                        country,
                    },
                });
            }
        },
        getNeighbour(country, state) {
            log("getCities", { country, state });

            if (this.socketIsOpen) {
                this.sendSocketMessageForLocation("location find-cities", {
                    siteId: this.siteId,
                    country,
                    state,
                });
            } else {
                this.socketMessageBuffer.push({
                    key: "location find-cities",
                    data: {
                        siteId: this.siteId,
                        country,
                    },
                });
            }
        },
        listenSocket() {
            this.socketSub = socketMessageStream.subscribe((message) => {
                const { cmd, data } = message;
                if (cmd === "find_states_response") {
                    const { states } = data;
                    this.newCities = states;
                    if (!this.selectedCityId) {
                        this.selectedCityId = 2170;
                    }
                }
                if (cmd === "find_cities_response") {
                    const { cities } = data;
                    this.newDistrict = cities;
                    if (!this.selectedDistrict) {
                        this.selectedDistrict = this.newDistrict[0].name;
                    }
                }
                this.renderInputs();
            });
        },
        telInputChangeHandler(value, id) {
            this.values[id] = this.selectedCountry + value;
        },
        reFillPreData() {
            this.fillPreSelectedSubject();
            if (!!this.preDefinedUserData && !!this.preDefinedUserData.initialized) {
                log("fillPreDefinedUserData running from inputs watcher", {
                    preDefinedUserData: this.preDefinedUserData,
                });
                this.fillPreDefinedUserData(this.preDefinedUserData);
            }
        },
        renderInputs() {
            const lastCustomLogin = JSON.parse(getPersistenceData("lastCustomLogins") || "[]")[0];

            for (let input of this.inputs) {
                if (input.type === "phone") {
                    this.values[input._id] = lastCustomLogin ? lastCustomLogin.phone : undefined;
                }
                // bu kısım şuanlık devredışı bıraktım visitor önceki giridği datayı almadık.
                //TODO: Üst satırdaki yorum satırı unutulmasın
                if (input.type === "select") this.values[input._id] = input.defaultOption;

                if (input.type === "email") this.values[input._id] = _.get(this.lastLoginData, "email");
                if (input.type === "fullname") this.values[input._id] = _.get(this.lastLoginData, "fullname");
                if (lastCustomLogin) {
                    const { customLoginFormValues } = lastCustomLogin;
                    if (Array.isArray(customLoginFormValues)) {
                        const maybeInput = customLoginFormValues.find((x) => x.input === input._id);
                        log.debug("maybeInput->", { maybeInput, input });
                        if (maybeInput && !!maybeInput.value) {
                            this.values[input._id] = maybeInput.value;
                        }
                    }
                }
            }
            log("this.values changed in renderInputs");
            this.values = _.cloneDeep(this.values);
            this.valuesUpdated(this.values);

            this.reFillPreData();
        },
        async fillPreSelectedSubject() {
            log("preSelectedDepartment", { preSelectedDepartment: this.preSelectedDepartment });
            if (this.preSelectedDepartment) {
                const { data } = await request.get("/public/subjects/get-all");
                const foundDepartment = data.find(
                    (x) =>
                        x.languageContent.map((x) => x.name).includes(this.preSelectedDepartment) ||
                        x._id === this.preSelectedDepartment,
                );
                log("preSelectedDepartment", { foundDepartment, all: data });
                if (foundDepartment) {
                    const departmentId = foundDepartment._id;
                    const subjectTitle = (
                        _.get(foundDepartment, "languageContent", []).find(
                            (x) => x.languageCode === _.get(this.$i18n, "locale", "tr"),
                        ) || { name: "" }
                    ).name.toLowerCase();
                    const optionSubject = this.subjects
                        .map((type) => {
                            const label = type.label;
                            return label;
                        })
                        .find((x) => x.toLowerCase() === subjectTitle);
                    log("preSelectedDepartment", { subjectTitle, optionSubject });
                    this.selectedSubject = optionSubject || subjectTitle;
                    const maybeInput = this.inputs.find((x) => x.name.trim().toLowerCase() === "subject");
                    log("preSelectedDepartment", { foundDepartment, maybeInput });
                    if (maybeInput) {
                        this.$set(this.values, maybeInput._id, departmentId);
                        log("this.values changed in fillPreSelectedSubject");
                        this.values = _.cloneDeep(this.values);
                        this.valuesUpdated(this.values);
                        // this.renderCount += 1;
                        // this.$nextTick();
                    }
                }
            }
        },
        blur() {
            log("blur called");
            // if (!_.isEqual(this.lastReportedValues, this.values)) {
            //     this.valuesUpdated(this.values);
            // }
        },
        changeAutoFocus(id, inputType = null) {
            log(id, "changeAutoFocus called");
            if (inputType === "phoneNumber") {
                this.phoneLabelVisible = true;
            }
        },
        fillPreDefinedUserData(data) {
            const { initialized, ...fields } = data;
            log("preDefinedUserData changed", {
                data,
                fields,
                inputs: this.inputs,
            });
            if (fields) {
                const values = _.cloneDeep(this.values);
                Object.keys(fields).forEach((key) => {
                    const value = fields[key];
                    key = key === "name" ? "fullname" : key;
                    const maybeInput = this.inputs.find(
                        (x) => x.name.trim().toLowerCase() === key.trim().toLowerCase(),
                    );
                    log("predefine set", {
                        maybeInput,
                        key,
                        value,
                        inputs: this.inputs,
                        fields,
                        values,
                    });
                    if (maybeInput) {
                        values[maybeInput._id] = value;
                    }
                });
                const oldValues = _.cloneDeep(this.values);
                const isChanged = !_.isEqual(oldValues, values);
                if (isChanged) {
                    log("this.values changed in fillPreDefinedUserData");
                    this.values = _.cloneDeep(values);
                    log("values sending to parent from fillPreDefinedUserData", values);
                    this.valuesUpdated(values);
                }
            }
        },
        reportValues(val) {
            log.debug("reportValues called", val);
            this.lastReportedValues = { ...val };
            if (typeof val === "object") {
                const valuesAsArray = Object.keys(val).map((id) => ({
                    input: id,
                    value: val[id],
                }));
                const result = { values: valuesAsArray, validator: this.$validator };
                return result;
            } else {
                const result = { values: [], validator: this.$validator };
                return result;
            }
        },
        hallet(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
    },

    watch: {
        socketIsOpen(isOpen) {
            if (isOpen) {
                this.socketMessageBuffer.forEach((item) => this.sendSocketMessageForLocation(item.key, item.data));
                this.socketMessageBuffer = [];
            }
        },
        selectedCityId(newValue) {
            for (let input of this.inputs) {
                if (input.type === "cityAndDistrict" && input.visible) {
                    this.selectedDistrict = null;
                    this.getNeighbour("TR", this.selectedCity.state_code);
                }
                if (input.type === "city" && input.visible) {
                    this.values[input._id] = this.selectedCity.name;
                }
            }
            log("this.values changed in selectedCityId.watcher");
            this.values = _.cloneDeep(this.values);
            this.valuesUpdated(this.values);
            this.reFillPreData();
        },
        inputs: {
            handler: function(newValue) {
                if (newValue && Array.isArray(newValue)) {
                    log("this.values changed in inputs.watcher");
                    this.values = newValue.reduce((acc, cur) => {
                        acc[cur._id] = undefined;
                        return acc;
                    }, {});

                    if (!!this.preDefinedUserData && !!this.preDefinedUserData.initialized) {
                        log("fillPreDefinedUserData running from inputs watcher", {
                            preDefinedUserData: this.preDefinedUserData,
                        });
                        this.fillPreDefinedUserData(this.preDefinedUserData);
                    }
                }
            },
            deep: true,
        },
        selectedDistrict(newValue) {
            let inputId = this.inputs.filter((input) => input.type === "cityAndDistrict").map((input) => input._id);
            log("this.values changed in selectedDistrict.watcher");
            this.values[inputId] = `${this.selectedCity.name}/${newValue}`;
            this.values = _.cloneDeep(this.values);
            this.valuesUpdated(this.values);
            this.reFillPreData();
        },
        selectedSubject(newVal) {
            const subjectInput = this.inputs.find((x) => x.type === "subject");
            const maybeSubject = this.subjects.find(
                (x) => (x.label || "").toLowerCase() === (newVal || "").toLowerCase(),
            );
            log("selectedSubject", { newVal, maybeSubject, subjectInput });
            if (!subjectInput) return;
            log("this.values changed in const.watcher");
            if (maybeSubject) {
                this.values[subjectInput._id] = maybeSubject.id;
                this.$set(this.values, subjectInput._id, maybeSubject.id);
            } else {
                this.$set(this.values, subjectInput._id, undefined);
            }
            this.values = _.cloneDeep(this.values);
            log("values sending to parent from selectedSubject", this.values);
            this.valuesUpdated(this.values);
        },
        preDefinedUserData: {
            handler: function(val) {
                if (!val) return;
                if (!val.initialized) return;
                log("fillPreDefinedUserData running from preDefinedUserData watcher", {
                    preDefinedUserData: this.preDefinedUserData,
                });
                this.fillPreDefinedUserData(val);
            },
            deep: true,
        },
        preSelectedDepartment() {
            log("preSelectedDepartment");
            this.fillPreSelectedSubject();
        },
        renderCount(newValue) {
            log("renderCount changed");
        },
        values: {
            handler: function(newValue) {
                log("values changed in watch", newValue);
                if (newValue && this.reportValues) {
                    log("report values calling in values watcher", newValue);
                    this.reportValues(newValue);
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped src="../../assets/scss/components/v2/CustomLoginForm.scss" />
<style lang="scss" src="../../assets/scss/components/v2/CustomLoginForm.global.scss" />
<style lang="scss" scoped>
.descriptionLabel {
    padding-bottom: 10px !important;
}

md-field {
    margin-bottom: 10px;

    .warning-icon {
        margin-left: 15px;
    }
}

.field-custom {
    margin-bottom: 25px !important;
}

.customCheck {
    border: transparent !important;
    z-index: 9999;
}

.field-name {
    margin-bottom: 5px;
}

.label-top {
    top: -9px !important;
    left: 7px !important;
    font-size: 10px !important;
    color: black;
}

.md-invalid {
    .label-top {
        color: red !important;
    }
}

.checkbox-span {
    a {
        display: inline-block !important;
    }
}
</style>
<style lang="scss">
.custom-form {
    .ant-select-selection {
        background: transparent !important;

        &:active &:focus {
            border-color: transparent !important;
            box-shadow: none !important;
            outline:none !important;
        }
    }

    .ant-select-selection .ant-select-selection--single {
        &:active, &:focus {
            .ant-select-selection {
                border: none !important;
            }
        }
    }
}
.ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
    border-color: transparent !important;
    box-shadow: none !important;
    outline:none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/V2/CustomLoginForm.vue